import http from './base/http';
import Config from '@/config';
import { CommonApi } from '@/api';

interface DataResponse {
  data: {
    ssoInfo?: {
      accessToken: string;
      refreshToken: string;
      userId: string;
    };
    tripsInfo?: {
      tripIds: string[];
      airlineProfile: string;
      sId?: string;
      departCabinClass?: string;
      returnCabinClass?: string;
      extendedParams?: {
        isDepartCabinBusiness?: boolean;
        isReturnCabinBusiness?: boolean;
      };
    };
    searchInfo?: SearchInfo;
    openId?: string;
    bgKey?: string;
    mpurl?: string;
  };
  token: string;
}

interface SearchInfo {
  locationId: string;
  locationName: string;
  totalRooms: string;
  checkin: string;
  checkout: string;
  children: string;
  adults: string;
  totalAdults: string;
  totalChildren: string;
  externalAuth: string;
  wmpurl: string;
}

// get data by UUID
export const getDataByUUID = async (uuid: string): Promise<DataResponse> => {
  try {
    const url = `${Config.BFF_SERVICE.URL}/hainan-bff/data/get?uuid=${uuid}`;
    const response = await http.get<BFFResponse<DataResponse>>(url);
    return response.data;
  } catch (error) {
    console.error('Failed to get data by UUID:', error);
    throw error;
  }
};
